import styled from "styled-components";
import { MenuItem, Select } from "@mui/material";

export const HeaderTable = styled.div`
  border-radius: 3px;
  padding: 25px 30px;
  display: flex;
  justify-content: space-between;
  margin-bottom: 25px;

  background-color: rgba(0, 0, 0, 0.04);
  font-size: 14px;
`;

export const ItemTable = styled.div`
  border-radius: 3px;
  padding: 25px 30px;
  display: flex;
  justify-content: space-between;
  margin-bottom: 25px;
  box-shadow: 0px 0px 9px 0px rgba(0, 0, 0, 0.1);
`;

export const ItemsList = styled.div`
  max-height: 460px;
  width: 100%;
`;

export const ContainerPagination = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  margin: 30px 0 20px 0;
`;

export const Arrows = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;

  li {
    button {
      background: #f2f4f8;
      color: #819dff;
      border: none;
      width: 26px;
      height: 26px;
    }
    .Mui-selected {
      background-color: #819dff;
      color: #ffffff;
      border-radius: 3px;
    }
  }
`;

export const MenuItemStyled = styled(MenuItem)`
  font-family: "Inter";
  font-size: 14px;
`;

export const SelectStyled = styled(Select)`
  padding-left: 4px;
  margin-left: 10px;
  color: #46505a;
  border: 1px solid #c6ccd7;
  border-radius: 16px;
  height: 32px;

  legend {
    span {
      display: none;
    }
  }
`;
